import { useMutation } from "@tanstack/react-query";

import { BugCoverageResponse } from "@oracus/shared/api/bug-coverage";

import { apiClient } from "./client.ts";

export function useAnalyzeBugCoverage() {
  return useMutation({
    mutationFn: (ticketId: string) =>
      apiClient.post(
        `/api/bug-coverage/${encodeURIComponent(ticketId)}`,
        undefined,
        BugCoverageResponse,
      ),
  });
}
